var classes = {"link":"index-module_link__DRIj5","themed":"index-module_themed__YBCsG","disabled":"index-module_disabled__Fjlnb","extra-small":"index-module_extra-small__BB8LC","small":"index-module_small__f1OvZ","medium":"index-module_medium__V-LnX","book":"index-module_book__TWSSt","semibold":"index-module_semibold__vFsrf"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
